import { renderChatMarkdown } from '../../lib/chat-markdown';
import { MarkdownView } from '../MarkdownView';

function section(heading: string, text: string): { heading: string; text: string } | null {
  const value = text.trim();
  return value ? { heading, text: value } : null;
}

export function ProposalPreview({
  number,
  title,
  issuedOn,
  customerName,
  preparedFor,
  preparedBy,
  summary,
  purpose,
  understanding,
  approach,
  scope,
  stages,
  deliverables,
  commercial,
  assumptions,
  whyMaxiron,
  nextSteps,
}: {
  number?: string;
  title: string;
  issuedOn: string;
  customerName: string;
  preparedFor: string;
  preparedBy: string;
  summary: string;
  purpose: string;
  understanding: string;
  approach: string;
  scope: string;
  stages: string;
  deliverables: string;
  commercial: string;
  assumptions: string;
  whyMaxiron: string;
  nextSteps: string;
}) {
  const sections = [
    { id: 'summary', ...section('Executive summary', summary || purpose) },
    { id: 'understanding', ...section('Our understanding', understanding) },
    { id: 'approach', ...section('Proposed approach', approach || scope) },
    { id: 'stages', ...section('Engagement stages', stages) },
    { id: 'deliverables', ...section('Deliverables', deliverables) },
    { id: 'commercial', ...section('Commercial summary', commercial) },
    { id: 'assumptions', ...section('Assumptions, pre-requisites and information required', assumptions) },
    { id: 'why', ...section('Why MaxIron', whyMaxiron) },
    { id: 'next', ...section('Proposed next steps', nextSteps) },
  ].filter((item): item is { id: string; heading: string; text: string } => Boolean(item.heading));
  const rows: [string, string][] = [
    ['Document reference', number || 'Draft'],
    ['Version', '1.0'],
    ['Date', issuedOn],
    ['Owner', 'MaxIron Ltd'],
    ['Classification', 'Proposal, Commercial in Confidence'],
    ['Prepared for', preparedFor || customerName],
    ['Prepared by', preparedBy || 'MaxIron Ltd'],
    ['Customer', customerName],
  ];

  return (
    <article className="doc-sheet doc-proposal">
      <h1>{title || 'Proposal'}</h1>
      <table className="doc-meta">
        <tbody>
          {rows.map(([label, value]) => (
            <tr key={label}><td>{label}</td><td>{value}</td></tr>
          ))}
        </tbody>
      </table>
      {sections.map((item) => (
        <section key={item.id} id={`preview-${item.id}`}>
          <h2>{item.heading}</h2>
          <MarkdownView html={renderChatMarkdown(item.text)} />
        </section>
      ))}
      <h2>Change Log</h2>
      <table className="doc-log">
        <thead><tr><th>Version</th><th>Date</th><th>Author</th><th>Notes</th></tr></thead>
        <tbody><tr><td>1.0</td><td>{issuedOn}</td><td>MaxIron</td><td>Initial proposal.</td></tr></tbody>
      </table>
    </article>
  );
}
